import { CircleCheck } from 'lucide-react';
import React from 'react';
import Spacing from '../Spacing';
import { useNavigate } from 'react-router-dom';
import { setSecureData } from '../../helpers';
import { setCaregapAdditionalData } from '../../Session';
import { Config } from '../../Config';

export default function BorderCard({
  icon,
  title,
  subTitle,
  donePercentage,
  pendingPercentage,
  numberOfDoneItem,
  numberOfPendingItem,
  doneItem,
  pendingItem,
  completed,
  queryParamsId,
  isReporting,
  setIsReporting = () => {}
}) {
  const navigate = useNavigate();
  
  // const [isReporting, setIsReporting] = useState(2);

  const queryParams = new URLSearchParams({
    quality_measure: JSON.stringify([
      { id: queryParamsId, status: isReporting === 1 ? "pending" : "completed" }
    ])
  }).toString();

  const handleNavigation = async () => {
    var caregapComponents = {
      'icon' : icon,
      'title' : title,
      'sub_title' : subTitle,
      'done_percentage' : donePercentage,
      'pending_percentage' : pendingPercentage,
      'done_item' : numberOfDoneItem,
      'pending_item' : numberOfPendingItem,
      'total_done_item' : doneItem,
      'total_pending_item' : pendingItem,
      'completed' : completed,
    }
    setCaregapAdditionalData(caregapComponents);
    await setSecureData("caregapAdditionalData", JSON.stringify(caregapComponents));
    navigate(`/caregap-plus?${queryParams}`);
  };

  return (
    
    <div className='relative'>
      {/* <NavLink to={`/caregap-plus?${queryParams}`}> */}
        <div className="docpro_border_card pointer" onClick={handleNavigation}>
          <div className='w-full'>
            <img src={`${Config.appUrl}/images/icons/${icon}.svg`} width={28} alt="Icon" />
            <Spacing lg="4" sm="4" />
            <h3 className="docpro_fs_16 docpro_mb_0">{title}</h3>
            <p>{subTitle}</p>

            {completed ? (
              <CircleCheck width={20} height={20} style={{ color: '#12A594' }} />
            ) : (
              <>
                <div className="docpro_progress_title docpro_fs_12 pt-1">
                  <span>{donePercentage}% Done ({pendingItem || 0} patients remaining)</span>
                </div>
                <Spacing lg="4" sm="4" />
                <div className="docpro_progress">
                  <div
                    className="docpro_progress_in"
                    style={{ width: `${donePercentage ? donePercentage : 0}%` }}
                  ></div>
                </div>
              </>
            )}

            {/* {isReporting === 1 && (
              completed ? (
                <CircleCheck width={20} height={20} style={{ color: '#12A594' }} />
              ) : (
                <>
                  <div className="docpro_progress_title docpro_fs_12 pt-1">
                    <span>{pendingPercentage}%</span>
                    <span>{numberOfPendingItem}</span>
                  </div>
                  <Spacing lg="4" sm="4" />
                  <div className="docpro_progress">
                    <div
                      className="docpro_progress_in"
                      style={{ width: `${pendingPercentage ? pendingPercentage : 0}%` }}
                    ></div>
                  </div>
                </>
              )
            )}
            {isReporting === 2 && (
              completed ? (
                <CircleCheck width={20} height={20} style={{ color: '#12A594' }} />
              ) : (
                <>
                  <div className="docpro_progress_title docpro_fs_12 pt-1">
                    <span>{donePercentage}%</span>
                    <span>{numberOfDoneItem}</span>
                  </div>
                  <Spacing lg="4" sm="4" />
                  <div className="docpro_progress">
                    <div
                      className="docpro_progress_in"
                      style={{ width: `${donePercentage ? donePercentage : 0}%` }}
                    ></div>
                  </div>
                </>
              )
            )} */}
          </div>
        </div>
      {/* </NavLink> */}

      {/* <div className='absolute top-0 right-0 docpro_dashboard_gaps'>
        <div className="docpro_tab_btns_2 mt-1 mx-1 mb-1 px-2 py-2">
          <button
            type="button"
            className={`docpro_fs_12 ${isReporting === 1 ? "active" : ""}`}
            onClick={() => setIsReporting(1)}
          >
            Pending
          </button>
          <button
            type="button"
            className={`docpro_fs_12 ${isReporting === 2 ? "active" : ""}`}
            onClick={() => setIsReporting(2)}
          >
            Done
          </button>
        </div>
      </div> */}

    </div>
  );
}
